import { number, shape, string } from 'prop-types';

/**
 * Response from wx/observations/current API
 * https://docs.google.com/document/d/1UOjfN1j54Ocmwj-zYCcHG_RM1tlNceW_qlzz0wVILXA/edit
 */
export const currentWeatherConditionsType = shape({
  cloudCeiling: number,
  cloudCoverPhrase: string.isRequired,
  dayOfWeek: string.isRequired,
  dayOrNight: string.isRequired,
  expirationTimeUtc: number.isRequired,
  iconCode: number.isRequired,
  iconCodeExtend: number.isRequired,
  obsQualifierCode: string,
  obsQualifierSeverity: number,
  precip1Hour: number,
  precip6Hour: number,
  precip24Hour: number,
  pressureAltimeter: number.isRequired,
  pressureChange: number.isRequired,
  pressureMeanSeaLevel: number.isRequired,
  pressureTendencyCode: number.isRequired,
  pressureTendencyTrend: string.isRequired,
  relativeHumidity: number.isRequired,
  snow1Hour: number,
  snow6Hour: number,
  snow24Hour: number,
  sunriseTimeLocal: string,
  sunriseTimeUtc: number,
  sunsetTimeLocal: string,
  sunsetTimeUtc: number,
  temperature: number.isRequired,
  temperatureChange24Hour: number.isRequired,
  temperatureDewPoint: number.isRequired,
  temperatureFeelsLike: number.isRequired,
  temperatureHeatIndex: number.isRequired,
  temperatureMax24Hour: number.isRequired,
  temperatureMaxSince7Am: number.isRequired,
  temperatureMin24Hour: number.isRequired,
  temperatureWindChill: number.isRequired,
  uvDescription: string.isRequired,
  uvIndex: number.isRequired,
  validTimeLocal: string.isRequired,
  validTimeUtc: number.isRequired,
  visibility: number.isRequired,
  windDirection: number.isRequired,
  windDirectionCardinal: string.isRequired,
  windGust: number,
  windSpeed: number.isRequired,
  wxPhraseLong: string.isRequired,
  wxPhraseMedium: string, // this is still present in API docs but apparently being phased out, leave in for now here though it's not being used in the app anymore
  wxPhraseShort: string,
});
